import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  waitTime: 0,
  chatEnabled: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_CHAT_RESPONSE:
      return Object.assign({}, state, { isLoading: false,
        error: false,
        waitTime: action.payload.waitTime,
        chatEnabled: action.payload.isChatEnabled,
      });
    case types.RECEIVE_CHAT_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: true,
        chatEnabled: false,
      });
    default:
      return state;
  }
}
